declare namespace $ {

	type $bog_theme_toggle__theme_auto_bog_pazzle_1 = $mol_type_enforce<
		ReturnType< $bog_pazzle['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $bog_pazzle_menu__resumable_bog_pazzle_2 = $mol_type_enforce<
		ReturnType< $bog_pazzle['resumable'] >
		,
		ReturnType< $bog_pazzle_menu['resumable'] >
	>
	type $bog_pazzle_menu__saves_count_bog_pazzle_3 = $mol_type_enforce<
		ReturnType< $bog_pazzle['saves_count'] >
		,
		ReturnType< $bog_pazzle_menu['saves_count'] >
	>
	type $bog_pazzle_menu__home_bog_pazzle_4 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_home'] >
		,
		ReturnType< $bog_pazzle_menu['home'] >
	>
	type $bog_pazzle_menu__play_bog_pazzle_5 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_play'] >
		,
		ReturnType< $bog_pazzle_menu['play'] >
	>
	type $bog_pazzle_menu__saves_bog_pazzle_6 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_saves'] >
		,
		ReturnType< $bog_pazzle_menu['saves'] >
	>
	type $bog_pazzle_menu__help_bog_pazzle_7 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_help'] >
		,
		ReturnType< $bog_pazzle_menu['help'] >
	>
	type $bog_pazzle_board__image_uri_bog_pazzle_8 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_image'] >
		,
		ReturnType< $bog_pazzle_board['image_uri'] >
	>
	type $bog_pazzle_board__rows_bog_pazzle_9 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_rows'] >
		,
		ReturnType< $bog_pazzle_board['rows'] >
	>
	type $bog_pazzle_board__columns_bog_pazzle_10 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_columns'] >
		,
		ReturnType< $bog_pazzle_board['columns'] >
	>
	type $bog_pazzle_board__numbers_bog_pazzle_11 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_numbers'] >
		,
		ReturnType< $bog_pazzle_board['numbers'] >
	>
	type $bog_pazzle_board__order_bog_pazzle_12 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_order'] >
		,
		ReturnType< $bog_pazzle_board['order'] >
	>
	type $bog_pazzle_upload__image_uri_bog_pazzle_13 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_image'] >
		,
		ReturnType< $bog_pazzle_upload['image_uri'] >
	>
	type $bog_pazzle_upload__picked_bog_pazzle_14 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_picked'] >
		,
		ReturnType< $bog_pazzle_upload['picked'] >
	>
	type $bog_pazzle_upload__grid_rows_bog_pazzle_15 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_rows'] >
		,
		ReturnType< $bog_pazzle_upload['grid_rows'] >
	>
	type $bog_pazzle_upload__grid_columns_bog_pazzle_16 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_columns'] >
		,
		ReturnType< $bog_pazzle_upload['grid_columns'] >
	>
	type $bog_pazzle_upload__numbers_bog_pazzle_17 = $mol_type_enforce<
		ReturnType< $bog_pazzle['draft_numbers'] >
		,
		ReturnType< $bog_pazzle_upload['numbers'] >
	>
	type $bog_pazzle_upload__start_bog_pazzle_18 = $mol_type_enforce<
		ReturnType< $bog_pazzle['start'] >
		,
		ReturnType< $bog_pazzle_upload['start'] >
	>
	type $bog_pazzle_upload__Preview_bog_pazzle_19 = $mol_type_enforce<
		ReturnType< $bog_pazzle['Preview'] >
		,
		ReturnType< $bog_pazzle_upload['Preview'] >
	>
	type $bog_pazzle_board__playable_bog_pazzle_20 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_pazzle_board['playable'] >
	>
	type $bog_pazzle_board__image_uri_bog_pazzle_21 = $mol_type_enforce<
		ReturnType< $bog_pazzle['image'] >
		,
		ReturnType< $bog_pazzle_board['image_uri'] >
	>
	type $bog_pazzle_board__rows_bog_pazzle_22 = $mol_type_enforce<
		ReturnType< $bog_pazzle['rows'] >
		,
		ReturnType< $bog_pazzle_board['rows'] >
	>
	type $bog_pazzle_board__columns_bog_pazzle_23 = $mol_type_enforce<
		ReturnType< $bog_pazzle['columns'] >
		,
		ReturnType< $bog_pazzle_board['columns'] >
	>
	type $bog_pazzle_board__numbers_bog_pazzle_24 = $mol_type_enforce<
		ReturnType< $bog_pazzle['numbers'] >
		,
		ReturnType< $bog_pazzle_board['numbers'] >
	>
	type $bog_pazzle_board__order_bog_pazzle_25 = $mol_type_enforce<
		ReturnType< $bog_pazzle['order'] >
		,
		ReturnType< $bog_pazzle_board['order'] >
	>
	type $bog_pazzle_board__moves_bog_pazzle_26 = $mol_type_enforce<
		ReturnType< $bog_pazzle['moves'] >
		,
		ReturnType< $bog_pazzle_board['moves'] >
	>
	type $bog_pazzle_board__time_bog_pazzle_27 = $mol_type_enforce<
		ReturnType< $bog_pazzle['time'] >
		,
		ReturnType< $bog_pazzle_board['time'] >
	>
	type $bog_pazzle_board__best_bog_pazzle_28 = $mol_type_enforce<
		ReturnType< $bog_pazzle['best'] >
		,
		ReturnType< $bog_pazzle_board['best'] >
	>
	type $bog_pazzle_board__peek_bog_pazzle_29 = $mol_type_enforce<
		ReturnType< $bog_pazzle['peek'] >
		,
		ReturnType< $bog_pazzle_board['peek'] >
	>
	type $bog_pazzle_board__apply_bog_pazzle_30 = $mol_type_enforce<
		ReturnType< $bog_pazzle['move'] >
		,
		ReturnType< $bog_pazzle_board['apply'] >
	>
	type $bog_pazzle_board__again_bog_pazzle_31 = $mol_type_enforce<
		ReturnType< $bog_pazzle['again'] >
		,
		ReturnType< $bog_pazzle_board['again'] >
	>
	type $bog_pazzle_board__home_bog_pazzle_32 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_home'] >
		,
		ReturnType< $bog_pazzle_board['home'] >
	>
	type $bog_pazzle_board__saves_bog_pazzle_33 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_saves'] >
		,
		ReturnType< $bog_pazzle_board['saves'] >
	>
	type $mol_button_minor__hint_bog_pazzle_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_pazzle_35 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_home'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_pazzle_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_pazzle_layout__Menu_bog_pazzle_37 = $mol_type_enforce<
		ReturnType< $bog_pazzle['Menu'] >
		,
		ReturnType< $bog_pazzle_layout['Menu'] >
	>
	type $bog_pazzle_layout__Upload_bog_pazzle_38 = $mol_type_enforce<
		ReturnType< $bog_pazzle['Upload'] >
		,
		ReturnType< $bog_pazzle_layout['Upload'] >
	>
	type $bog_pazzle_play__moves_bog_pazzle_39 = $mol_type_enforce<
		ReturnType< $bog_pazzle['moves'] >
		,
		ReturnType< $bog_pazzle_play['moves'] >
	>
	type $bog_pazzle_play__time_bog_pazzle_40 = $mol_type_enforce<
		ReturnType< $bog_pazzle['time'] >
		,
		ReturnType< $bog_pazzle_play['time'] >
	>
	type $bog_pazzle_play__peek_bog_pazzle_41 = $mol_type_enforce<
		ReturnType< $bog_pazzle['peek'] >
		,
		ReturnType< $bog_pazzle_play['peek'] >
	>
	type $bog_pazzle_play__again_bog_pazzle_42 = $mol_type_enforce<
		ReturnType< $bog_pazzle['again'] >
		,
		ReturnType< $bog_pazzle_play['again'] >
	>
	type $bog_pazzle_play__Game_bog_pazzle_43 = $mol_type_enforce<
		ReturnType< $bog_pazzle['Game'] >
		,
		ReturnType< $bog_pazzle_play['Game'] >
	>
	type $bog_pazzle_saves__open_bog_pazzle_44 = $mol_type_enforce<
		ReturnType< $bog_pazzle['open'] >
		,
		ReturnType< $bog_pazzle_saves['open'] >
	>
	type $bog_pazzle_saves__create_bog_pazzle_45 = $mol_type_enforce<
		ReturnType< $bog_pazzle['go_home'] >
		,
		ReturnType< $bog_pazzle_saves['create'] >
	>
	export class $bog_pazzle extends $mol_page {
		Theme( ): $bog_theme_auto
		caption( ): string
		Theme_toggle( ): $bog_theme_toggle
		screen( ): readonly(any)[]
		Back_icon( ): $mol_icon_arrow_left
		resumable( ): boolean
		saves_count( ): number
		Menu( ): $bog_pazzle_menu
		draft_image( ): string
		draft_picked( next?: any ): any
		draft_rows( next?: number ): number
		draft_columns( next?: number ): number
		draft_numbers( next?: boolean ): boolean
		draft_order( ): readonly(number)[]
		Preview( ): $bog_pazzle_board
		Upload( ): $bog_pazzle_upload
		moves( ): number
		time( ): string
		image( ): string
		rows( ): number
		columns( ): number
		numbers( ): boolean
		order( ): readonly(number)[]
		best( ): string
		Game( ): $bog_pazzle_board
		plugins( ): readonly(any)[]
		title( ): ReturnType< $bog_pazzle['caption'] >
		tools( ): readonly(any)[]
		body( ): ReturnType< $bog_pazzle['screen'] >
		Back( ): $mol_button_minor
		go_home( next?: any ): any
		go_play( next?: any ): any
		go_saves( next?: any ): any
		go_help( next?: any ): any
		start( next?: any ): any
		again( next?: any ): any
		move( next?: any ): any
		open( next?: any ): any
		peek( next?: boolean ): boolean
		Home( ): $bog_pazzle_layout
		Play( ): $bog_pazzle_play
		Saves( ): $bog_pazzle_saves
		Help( ): $bog_pazzle_help
	}
	
}

//# sourceMappingURL=pazzle.view.tree.d.ts.map